import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor() { }

  IsListEmpty(list: any) : boolean {
    return !list?.length;
  }

  date_TO_String(date_Object: Date): string {
    // get the year, month, date, hours, and minutes seprately and append to the string.
    let date_String: string =
      date_Object.getFullYear() +
      "_" +
      (date_Object.getMonth() + 1) +
      "_" +
      +date_Object.getDate();
    return date_String;
  }


  parseCustomDate(dateStr: string): Date | null {
    if (!dateStr || typeof dateStr !== 'string') return null;

    const [datePart, timePart] = dateStr.trim().split(' ');
    if (!datePart || !timePart) return null;

    const delimiter = datePart.includes('-') ? '-' : '/';
    const parts = datePart.split(delimiter).map(Number);

    let day, month, year;

    // Detect format based on delimiter type or numeric rules
    if (delimiter === '-') {
      // Format can be DD-MM-YYYY
      [day, month, year] = parts;
    } else {
      // "/" can be DD/MM/YYYY or MM/DD/YYYY so handling for both of these scenarios
      const [p1, p2, p3] = parts;

      if (p1 > 12) {
        day = p1; month = p2; year = p3;
      } else if (p2 > 12) {
        month = p1; day = p2; year = p3;
      } else {
        // default to MM/DD/YYYY 
        month = p1; day = p2; year = p3;
      }
    }
    const [hours, minutes, seconds] = timePart.split(':').map(Number);
    const date = new Date(year, month - 1, day, hours, minutes, seconds || 0);
    return isNaN(date.getTime()) ? null : date;
  }

conversionOfDateIntoLocalDateTime(date: Date): Date {
  const now = new Date();
  date.setHours(now.getHours(), now.getMinutes(), now.getSeconds());
  return date;
}

sameCalendarDate(firstDate: Date | null | undefined, secondDate: Date | null | undefined): boolean {
  if (!firstDate || !secondDate) {
    return false;
  }
  return firstDate.getFullYear() === secondDate.getFullYear()
    && firstDate.getMonth() === secondDate.getMonth()
    && firstDate.getDate() === secondDate.getDate();
}

convertDateIfChanged(selectedDate: Date,previousDate: Date | null | undefined): Date {
  if (previousDate && this.sameCalendarDate(selectedDate, previousDate)) {
    return new Date(previousDate);
  }
  return this.conversionOfDateIntoLocalDateTime(new Date(selectedDate));
}


}
